/**
 * Hub card badge / CTA honesty for Guests on requiresAuth intents (UAT J4.5).
 * Shared by SelectUseCasePage (via agenticIntents) and offline eval:hub-auth-copy.
 */

/**
 * @param {{ requiresAuth?: boolean, requiresPremium?: boolean, planBadge?: string, id?: string, ctaKey?: string, premiumTeaserKey?: string }} def
 * @param {string|null|undefined} tier
 * @returns {'hub.badge.sign_in'|'hub.badge.pro'|'hub.badge.pro_soft'|'hub.badge.free'}
 */
function hubIntentPlanBadgeKey(def, tier) {
    if (def?.requiresAuth && tier === 'guest') return 'hub.badge.sign_in';
    if (def?.requiresPremium) return 'hub.badge.pro';
    if (def?.planBadge === 'pro') return 'hub.badge.pro_soft';
    return 'hub.badge.free';
}

/**
 * @param {{ requiresAuth?: boolean, requiresPremium?: boolean, planBadge?: string }} def
 * @param {string|null|undefined} tier
 * @returns {'free'|'pro'|'sign_in'}
 */
function hubIntentBadgeTone(def, tier) {
    if (def?.requiresAuth && tier === 'guest') return 'sign_in';
    return def?.planBadge === 'pro' || def?.requiresPremium ? 'pro' : 'free';
}

/**
 * @param {{ requiresAuth?: boolean, id?: string, ctaKey?: string }} def
 * @param {string|null|undefined} tier
 * @returns {string}
 */
function hubIntentCtaKey(def, tier) {
    if (def?.requiresAuth && tier === 'guest') {
        if (def.id === 'rfp') return 'hub.intents.rfp.cta_guest';
        if (def.id === 'review') return 'hub.intents.review.cta_guest';
    }
    return def?.ctaKey || '';
}

/**
 * @param {{ requiresAuth?: boolean, requiresPremium?: boolean, planBadge?: string, premiumTeaserKey?: string }} def
 * @param {string|null|undefined} tier
 * @param {{ canViewPremiumArtifacts: boolean }} opts
 * @returns {string}
 */
function hubIntentFooterHintKey(def, tier, opts) {
    if (def?.requiresAuth && tier === 'guest') {
        return def.premiumTeaserKey || 'hub.badge.sign_in_hint';
    }
    if (
        def?.premiumTeaserKey
        && !opts?.canViewPremiumArtifacts
        && (def.requiresPremium || def.planBadge === 'pro')
    ) {
        return def.premiumTeaserKey;
    }
    return def?.planBadge === 'pro' ? 'hub.badge.pro_hint' : 'hub.badge.free_hint';
}

module.exports = {
    hubIntentPlanBadgeKey,
    hubIntentBadgeTone,
    hubIntentCtaKey,
    hubIntentFooterHintKey,
};
